import { Box, Flex, useDisclosure } from '@chakra-ui/react';
import { useRef, useState } from 'react';

import { CustomDrawer, SecondaryButton } from '../../../../components/custom';
import { LeadingIcon } from '../../../../components/icons';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import { IGetBillers } from '../../../../store/slices/billsPayment/getBillersCategorySlice';
import { resetPayBill } from '../../../../store/slices/billsPayment/payBillSlice';
import { IBillBeneficiary } from '../../../../types/beneficiary';
import { BuyAirtimeForm } from '../../PayBills/Airtime/BuyAirtimeForm';
import BuyCreditsForm from '../../PayBills/BetCredit/BuyCreditsForm';
import { BuyDataForm } from '../../PayBills/Data/BuyDataForm';
import { BuyElectricityForm } from '../../PayBills/Electricity/BuyElectricityForm';
import { BuyPlanForm } from '../../PayBills/Internet/BuyPlanForm';
import { BuySubscriptionForm } from '../../PayBills/TV/BuySubscriptionForm';
import BeneficiaryCardInfo from './BeneficiaryCardInfo';
import BeneficiaryCardMenu from './BeneficiaryCardMenu';

interface BeneficiaryCardProps {
  beneficiary: IBillBeneficiary;
  status: 'idle' | 'loading' | 'success' | 'failed';
  selectedTab: string;
  billCategoriesData:
    | [
        {
          id?: string;
          name?: string;
          description?: string;
          isActive?: boolean;
          billers?: IGetBillers[];
        }
      ]
    | null
    | undefined;
}

export default function BeneficiaryCard({
  beneficiary,
  status,
  selectedTab,
  billCategoriesData,
}: BeneficiaryCardProps) {
  const dispatch = useAppDispatch();

  const [isFormOpen, setIsFormOpen] = useState(false);
  const { onClose: onFormClose } = useDisclosure();
  const btnRef = useRef<HTMLButtonElement>(null);

  const handleDrawerClose = () => {
    dispatch(resetPayBill());
    setIsFormOpen(false);
    onFormClose();
  };

  const { value: networks } = useAppSelector((state) => state.billerCategories);
  //    if (selectedTab === 'betCredit') {
  //      const result: ITransaction[] =
  //        depositsValue?.data?.transactions?.map((deposit) => ({
  //          id: deposit.id ?? '',
  //          customer_id: deposit.clientId ?? '',
  //          biller_name: 'Bet9ja',
  //          created_at: deposit.createdAt ?? '',
  //        })) ?? [];

  //      return result;
  //    }
  //    if (mappedSelectedBillType === 'cable') {
  //      return beneficiariesList
  //        .filter(
  //          (transaction) =>
  //            transaction.billCategory?.toLowerCase() === 'television'
  //        )
  //        .map((transaction) => ({
  //          id: transaction.id,
  //          customer_id: transaction.customerId,
  //          biller_name: transaction.billerName || '',
  //          customer_account_no: transaction.billAlias,
  //          biller_id: transaction.billerId,
  //        }));
  //    }

  //    return beneficiariesList
  //      .filter(
  //        (transaction) =>
  //          transaction.billCategory?.toLowerCase() === mappedSelectedBillType
  //      )
  //      .map((transaction) => ({
  //        id: transaction.id,
  //        customer_id: transaction.customerId,
  //        biller_name: transaction.billerName || '',
  //        customer_account_no: transaction.billAlias,
  //        biller_id: transaction.billerId,
  //      }));
  //  })();

  const getBillersArrayByName = (nameToFind: string) => {
    if (!networks) {
      return [];
    }

    const network = networks.find((network) => network.name === nameToFind);
    return network?.billers || [];
  };

  return (
    <>
      <Box
        background="#fff"
        border="1px solid #EBEDEF"
        borderRadius="16px"
        p={4}
        h="full"
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
        _hover={{ borderColor: '#1a1c1f' }}
      >
        <Flex align="flex-start" justify="space-between" gap={2}>
          <Box flex={1} minW={0}>
            <BeneficiaryCardInfo
              beneficiary={beneficiary}
              billCategoriesData={billCategoriesData}
            />
          </Box>
          <BeneficiaryCardMenu beneficiary={beneficiary} />
        </Flex>
        <Box mt={6}>
          <SecondaryButton
            w="full"
            bg="#e0e3e6"
            color="#1A1C1F"
            leftIcon={<LeadingIcon />}
            _hover={{ bg: '#001419' }}
            isDisabled={status !== 'success'}
            onClick={() => setIsFormOpen(!isFormOpen)}
          >
            Buy
          </SecondaryButton>
        </Box>
      </Box>

      {selectedTab === 'airtime' && (
        <CustomDrawer
          isClosable
          btnRef={btnRef}
          isOpen={isFormOpen}
          onClose={handleDrawerClose}
          drawerHeader="Airtime"
        >
          <BuyAirtimeForm
            networks={getBillersArrayByName('Airtime')}
            selectedBillCategory={selectedTab}
            initialCustomerId={beneficiary?.customerId || undefined}
            handleClose={handleDrawerClose}
          />
        </CustomDrawer>
      )}

      {selectedTab === 'data' && (
        <CustomDrawer
          isClosable
          btnRef={btnRef}
          isOpen={isFormOpen}
          onClose={handleDrawerClose}
          drawerHeader="Data"
        >
          <BuyDataForm
            networks={getBillersArrayByName('Internet')}
            selectedBillCategory={selectedTab}
            initialPhoneNumber={beneficiary?.customerId || undefined}
          />
        </CustomDrawer>
      )}

      {selectedTab === 'internet' && (
        <CustomDrawer
          isClosable
          btnRef={btnRef}
          isOpen={isFormOpen}
          onClose={handleDrawerClose}
          drawerHeader="Internet"
        >
          <BuyPlanForm
            providers={getBillersArrayByName('Internet')}
            selectedBillCategory={selectedTab}
            initialCustomerId={beneficiary?.customerId || undefined}
          />
        </CustomDrawer>
      )}

      {selectedTab === 'tv' && (
        <CustomDrawer
          isClosable
          btnRef={btnRef}
          isOpen={isFormOpen}
          onClose={handleDrawerClose}
          drawerHeader="Television"
        >
          <BuySubscriptionForm
            providers={getBillersArrayByName('Television')}
            selectedBillCategory={selectedTab}
            initialCustomerId={beneficiary?.customerId || undefined}
          />
        </CustomDrawer>
      )}

      {selectedTab === 'electricity' && (
        <CustomDrawer
          isClosable
          btnRef={btnRef}
          isOpen={isFormOpen}
          onClose={handleDrawerClose}
          drawerHeader="Electricity"
        >
          <BuyElectricityForm
            providers={getBillersArrayByName('Electricity')}
            selectedBillCategory={selectedTab}
            initialCustomerId={beneficiary?.customerId || undefined}
          />
        </CustomDrawer>
      )}

      {selectedTab === 'betCredit' && (
        <CustomDrawer
          isClosable
          btnRef={btnRef}
          isOpen={isFormOpen}
          onClose={handleDrawerClose}
          drawerHeader="Fund Bet9ja Wallet"
        >
          <BuyCreditsForm
            clientIdFromProps={beneficiary?.customerId ?? undefined}
            providerNameFromProps="Bet9ja"
          />
        </CustomDrawer>
      )}
    </>
  );
}
